import { State } from 'redux/initialState';
import { useSelector } from 'react-redux';
import { FC } from 'react';
import { Tooltip } from 'react-tooltip';
import { useHistory } from 'react-router-dom';

import Button from 'modules/_shared/components/Buttons';
import { useTranslate } from 'hooks/useTranslate';
import { getOperationTooltip } from '../utils/getOperationTooltip';
import { useOperationDetailsPage } from '../context/OperationDetailsPageContext';
import { OperationData } from '../types/CustomOperation';

const baseURL = '/detalle-transacciones';
const tooltipClass = 'w-max-300px z-1000';
const tooltipPlace = 'bottom';

const OperationDetailsNavigationButtons: FC = () => {
  const { t } = useTranslate();
  const history = useHistory();

  const actualSociety = useSelector(
    (state: State) => state.society?.actualSociety
  );

  const { data } = useOperationDetailsPage();

  const previousOperation = data.operation?.previousOperation || null;
  const nextOperation = data.operation?.nextOperation || null;

  const getTooltip = (operation: OperationData | null, position: string) =>
    operation
      ? getOperationTooltip(position, operation)
      : t(`No${position}Operation`);

  const previousOperationTooltip = getTooltip(previousOperation, 'Previous');
  const nextOperationTooltip = getTooltip(nextOperation, 'Next');

  const handleClickNext = () => {
    if (nextOperation) {
      history.push(`${baseURL}/${actualSociety._id}/${nextOperation.id}`);
    }
  };

  const handleClickPrevious = () => {
    if (previousOperation) {
      history.push(`${baseURL}/${actualSociety._id}/${previousOperation.id}`);
    }
  };

  return (
    <>
      <ul className="transaction-details-nav-buttons-wrapper d-flex g-3">
        <li>
          <Button
            outlineStyle
            icon="chevron-left"
            disabled={!previousOperation}
            onClick={handleClickPrevious}
            data-tooltip-id="previousTooltip"
          />
        </li>

        <li>
          <Button
            outlineStyle
            icon="chevron-right"
            disabled={!nextOperation}
            onClick={handleClickNext}
            data-tooltip-id="nextTooltip"
          />
        </li>
      </ul>

      <Tooltip
        id="previousTooltip"
        className={tooltipClass}
        place={tooltipPlace}
      >
        {previousOperationTooltip}
      </Tooltip>

      <Tooltip id="nextTooltip" className={tooltipClass} place={tooltipPlace}>
        {nextOperationTooltip}
      </Tooltip>
    </>
  );
};

export default OperationDetailsNavigationButtons;
